import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import fileDownload from "js-file-download";
import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import { re } from "mathjs";
import { toast } from "react-toastify";

export default function IntroductionHtmlContext(props) {
  const data = props?.section?.positionContent;
  const doc = props?.section?.documents;
  const { section } = props;
  return (
    <>
      <Box sx={{ padding: 2, backgroundColor: "#fff" }}>
        <div dangerouslySetInnerHTML={{ __html: data }} />
        <Box sx={{ width: "100%" }}>
          <Stack spacing={2}>
            {doc?.map((r, index) => (
              <a
                style={{
                  textDecoration: "none",
                  color: "#2A93DB",
                  cursor: "pointer",
                }}
                key={index}
                onClick={() => handleDownload(r)}
              >
                <i className="fa fa-cloud-download" aria-hidden="true"></i>
                {r.documentName}
              </a>
            ))}
          </Stack>
        </Box>
        {section?.buData?.docs?.buSites && (
          <>
            {renderSites(
              section?.buData?.docs?.bus,
              false,
              section?.buData?.clientNames
            )}
            {renderSites(
              section?.buData?.docs?.buSites,
              true,
              section?.buData?.clientNames
            )}
          </>
        )}
      </Box>
    </>
  );
};

const handleDownload = (e) => {
  axios
    .get(
      BaseURL.baseUrl +
      "Documents/DownloadDocument?idAsFileName=" +
      e.documentId,
      {
        responseType: "blob",
      }
    ).then(res => {

      if (res?.data?.type == "application/json") {
        toast.error("File not found", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        // const url = URL.createObjectURL(res.data);
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = 'your-filename.pdf';
        // a.target = '_blank';
        // a.click();
      
         const file = new Blob([res.data], { type: "application/pdf" });
         //Build a URL from the file
         const fileURL = URL.createObjectURL(file);
         //Open the URL on new Window
         const pdfWindow = window.open();
         pdfWindow?.document?.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

        // const blob = new Blob([res.data], { type: res.headers['content-type'] });
        // const blobUrl = URL.createObjectURL(blob);
        // // Open the Blob URL in a new tab
        // window.open(blobUrl, '_blank');
        // // Revoke the Blob URL after opening to free up resources
        // URL.revokeObjectURL(blobUrl);
      }
    });
  //   fileDownload(res?.data, e.documentName);
  // });
};


function renderSites(bus, isBuSite, clientNames) {

  const heading = isBuSite
    ? "<h4 class='mt-3 fw-bold'>Site Specific Documentations</h4>"
    : "<h4 class='mt-3 fw-bold'>Business Unit Documentations</h4>";

  return (
    <>
      {clientNames?.map((clientName, index) => (
        <>
          {bus?.map(
            (busItem, index) =>
              busItem?.clientName === clientName && (
                <div key={index}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${index === 0
                        ? heading +
                        "<h5 class='mb-2'>" +
                        busItem?.clientName +
                        "</h5>"
                        : ""
                        }  <p class='my-3 ms-2'>${busItem?.businessUnitName} ${isBuSite
                          ? " - " + busItem?.businessUnitsiteName + "</p>"
                          : "</p>"
                        }`,
                    }}
                  />
                  <Box className="ms-3" sx={{ width: "100%" }}>
                    <Stack spacing={2}>
                      {busItem?.documents?.map((r, docIndex) => (
                        <a
                          style={{
                            textDecoration: "none",
                            color: "#2A93DB",
                            cursor: "pointer",
                          }}
                          key={docIndex}
                          onClick={() => handleDownload(r)}
                        >
                          <i
                            className="fa fa-cloud-download"
                            aria-hidden="true"
                          ></i>
                          {r?.documentName}
                        </a>
                      ))}
                    </Stack>
                  </Box>
                </div>
              )
          )}
        </>
      ))}
    </>
  );
}
